module.exports = __webpack_public_path__ + "img/Asia Multidana.b26792ac.png";